import { AlertLevel, AlertStatus } from './alerts';

// Single source of truth for level presentation (icon + colour + label) — imported by the admin
// list, the create/edit form's level tiles, the admin end-user preview cards, and the real-time
// toast stack in the shell, so all of them stay visually consistent. Icon names are Material
// Symbols (matIcon), colours are CSS custom properties — Information/Warning use two tokens in
// variables.scss (no blue/orange existed there before); Critical/Success/Maintenance reuse the
// existing SGL red/green/dark-gray tokens.
export interface AlertLevelMeta {
  icon: string;
  color: string;
  label: string;
}

export const ALERT_LEVEL_META: Record<AlertLevel, AlertLevelMeta> = {
  Information: { icon: 'info', color: 'var(--sgl-alert-info)', label: 'Information' },
  Warning: { icon: 'warning', color: 'var(--sgl-alert-warning)', label: 'Warning' },
  Critical: { icon: 'report', color: 'var(--sgl-red)', label: 'Critical' },
  Success: { icon: 'check_circle', color: 'var(--sgl-green-new)', label: 'Success' },
  Maintenance: { icon: 'build', color: 'var(--sgl-dark-gray)', label: 'Maintenance' }
};

export const ALERT_LEVELS: AlertLevel[] = ['Information', 'Warning', 'Critical', 'Success', 'Maintenance'];

export interface AlertStatusMeta {
  label: string;
  color: string;
}

// "Live now" is the spec's own display text for the Live status — the badge always shows this
// label, never the bare enum value.
export const ALERT_STATUS_META: Record<AlertStatus, AlertStatusMeta> = {
  Live: { label: 'Live now', color: 'var(--sgl-green)' },
  Scheduled: { label: 'Scheduled', color: 'var(--sgl-dark-gray)' },
  Expired: { label: 'Expired', color: 'var(--sgl-gray)' },
  Inactive: { label: 'Inactive', color: 'var(--sgl-gray)' }
};

export const ALERT_STATUSES: AlertStatus[] = ['Live', 'Scheduled', 'Expired', 'Inactive'];
